/**
 * Utilities for sdk-ai-services
 */

/**
 * Normalize URL by ensuring it ends with a trailing slash
 */
export function normalizeUrl(url: string): string {
	return url.endsWith('/') ? url : `${url}/`;
}

/**
 * Parse error to extract message
 */
export const parseError = (error: Error | string | object) => {
	if (error instanceof Error) {
		try {
			return JSON.parse(error.message);
		} catch {
			return error.message;
		}
	}
	if (typeof error === 'string') {
		return error;
	}
	return error;
};
